import React from 'react';
import { Upload } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface UploadDropzoneProps {
  dragActive: boolean;
  allowMultipleImages: boolean;
  onDrag: (e: React.DragEvent) => void;
  onDrop: (e: React.DragEvent) => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  inputId?: string;
}

export const UploadDropzone: React.FC<UploadDropzoneProps> = ({
  dragActive,
  allowMultipleImages,
  onDrag,
  onDrop,
  onChange,
  inputId = 'file-upload',
}) => {
  const { t } = useTranslation();
  return (
    <div
      onDragEnter={onDrag}
      onDragLeave={onDrag}
      onDragOver={onDrag}
      onDrop={onDrop}
      className={`mt-1 flex justify-center px-6 pt-5 pb-6 border-2 ${dragActive ? 'border-primary-500' : 'border-gray-300'} border-dashed rounded-md h-64 items-center text-center relative`}
    >
      <input
        id={inputId}
        name={inputId}
        type="file"
        className="sr-only"
        onChange={onChange}
        accept={allowMultipleImages ? '.jpg,.jpeg,.png,.mp4,.mov' : 'image/*,video/*,application/pdf'}
        multiple={allowMultipleImages}
      />
      <label htmlFor={inputId} className="w-full h-full flex flex-col items-center justify-center cursor-pointer">
        <Upload className={`mx-auto h-12 w-12 ${dragActive ? 'text-primary-500' : 'text-gray-400'}`} />
        <span className={`mt-2 block text-sm font-medium ${dragActive ? 'text-primary-600' : 'text-gray-900'}`}>
          {allowMultipleImages
            ? t('postContent.dropMediaHereMultiple', 'Drop your media here or click to upload (multiple allowed)')
            : t('postContent.dropMediaHere', 'Drop your media here or click to upload')}
        </span>
        <p className={`mt-1 text-xs ${dragActive ? 'text-primary-500' : 'text-gray-500'}`}>
          {allowMultipleImages
            ? t('postContent.supportedFormatsMultiple', 'Supports JPG, PNG, MP4, MOV up to 10MB each')
            : t('postContent.supportedFormats', 'Supports images, videos and PDFs up to 10MB')}
        </p>
      </label>
    </div>
  );
};


